import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Cleanup for the "duplicated address" bug introduced by older versions of
 * `AddressAutocomplete`: when Mapbox returned `full_address` already
 * starting with the venue / street name, the picker concatenated them as
 * `"<name> · <name>, <city> …"`. This helper detects that pattern and
 * collapses it back to the canonical full address.
 *
 *   "41 Rue Lamartine · 41 Rue Lamartine, 06000 Nice, France"
 *     →  "41 Rue Lamartine, 06000 Nice, France"
 *
 *   "Hôtel Ibis · Hôtel Ibis Nice, 41 Rue Lamartine, 06000 Nice"
 *     →  "Hôtel Ibis Nice, 41 Rue Lamartine, 06000 Nice"
 */
export function dedupeAddress(addr) {
  if (!addr || typeof addr !== "string") return addr || "";
  const sep = " · ";
  const idx = addr.indexOf(sep);
  if (idx === -1) return addr;
  const left = addr.slice(0, idx).trim();
  const right = addr.slice(idx + sep.length).trim();
  if (!left || !right) return addr;
  if (right.toLowerCase().startsWith(left.toLowerCase())) return right;
  return addr;
}
